import { style, animate, transition, trigger } from '@angular/animations';

/** imageToggle trigger using the generic animation */
export const imageToggle = trigger('imageToggle', [
  transition(':leave', [
    style({
      opacity: 1,
      transform: 'translateY(0)',
      height: '40dvh',
      margin: 'var(--care-pathway-gap)',
    }),
    animate(
      '300ms ease',
      style({
        opacity: 0,
        transform: 'translateY(-8px)',
        height: 0,
        margin: 0,
      })
    ),
  ]),
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(-8px)',
      height: 0,
      margin: 0,
    }),
    animate(
      '300ms ease',
      style({
        opacity: 1,
        transform: 'translateY(0)',
        height: '40dvh',
        margin: 'var(--care-pathway-gap)',
      })
    ),
  ]),
]);

/** descriptionExpand trigger reusing the same slideFade with height params */
export const descriptionExpand = trigger('descriptionExpand', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-8px)', height: 0 }),
    animate(
      '300ms ease',
      style({ opacity: 1, transform: 'translateY(0)', height: '*' })
    ),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0)', height: '*' }),
    animate(
      '300ms ease',
      style({ opacity: 0, transform: 'translateY(-8px)', height: 0 })
    ),
  ]),
]);
